import qivaIconSvg from '@/assets/qiva-icon.svg?raw'
import type { WorkflowRunActivityState } from '@/types'

export type TabIndicator = 'running' | 'needs-input' | 'finished'

export const DEFAULT_TAB_TITLE = 'Qiva'
export const DEFAULT_FAVICON_HREF = '/qiva-icon.svg'
export const PULSE_FRAME_MS = 200

const PULSE_FRAME_OPACITIES = [1, 0.85, 0.65, 0.45, 0.35, 0.45, 0.65, 0.85]

const TITLE_PREFIXES: Record<TabIndicator, string> = {
  running: 'Running',
  'needs-input': 'Input needed',
  finished: 'Finished',
}

const DOT_COLORS: Record<TabIndicator, string> = {
  running: '#9CA3AF',
  'needs-input': '#F59E0B',
  finished: '#277B9D',
}

const DARK_SCHEME_ICON_STYLE =
  '<style>@media (prefers-color-scheme: dark){path[fill="#2C2C2C"]{fill:#FFFFFF}path[fill="#F3AE7C"]{fill:#F88634}}</style>'

export function resolveTabIndicator(state: WorkflowRunActivityState | undefined, finished: boolean): TabIndicator | null {
  if (state === 'NeedsInput') return 'needs-input'
  if (state === 'Running') return 'running'
  return finished ? 'finished' : null
}

export function tabTitle(indicator: TabIndicator): string {
  return `${TITLE_PREFIXES[indicator]} · ${DEFAULT_TAB_TITLE}`
}

export function buildIndicatorFavicon(indicator: TabIndicator, frame: number): string {
  const opacity = PULSE_FRAME_OPACITIES[frame % PULSE_FRAME_OPACITIES.length]
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">' +
    DARK_SCHEME_ICON_STYLE +
    `<g transform="translate(0 27)">${qivaIconSvg}</g>` +
    `<circle cx="200" cy="200" r="50" fill="${DOT_COLORS[indicator]}" fill-opacity="${opacity}" stroke="#FFFFFF" stroke-width="12"/>` +
    '</svg>'

  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}
